module.exports = __webpack_public_path__ + "static/media/9DESA20.cee2a1f3.jpg";